import React from "react";
import { Form } from "antd";
import InputField from "../../../components/Input/Input";

const LocationFormBody = () => {
  return (
    <Form.Item
      label="Location Name"
      name="location_name"
      rules={[{ required: true, message: "Location Name is required" }]}
    >
      <InputField
        placeholder="Enter Location Name"
        data-testid="input-location-name"
      />
    </Form.Item>
  );
};

export default LocationFormBody;
